import React from 'react';
import GenericInternalTransfer from '../GenericInternalTransfer';

const UnassortedInternalTransfer = () => (
  <GenericInternalTransfer
    sectionName="Unassorted Section"
    sectionKey="Unassorted"
    backRoute="/sections/unassorted"
  />
);

export default UnassortedInternalTransfer;
